import { createTheme } from '@mui/material/styles';

export const FONT_FAMILY = {
  primary: 'Poppins, Arial, sans-serif',
  secondary: 'Open Sans, Arial, sans-serif',
};

export type ThemeColors = {
  blue: string;
  blueLight: string;
};

const colors: ThemeColors = {
  blue: "#007aff",
  blueLight: "#5fb0ff",
};

export const lightColors = [
  '#FFE5E5', // Light Pink
  '#E5F3FF', // Light Blue
  '#E5FFE5', // Light Green
  '#FFFBE5', // Light Yellow
  '#F0E5FF', // Light Purple
  '#FFE5F0', // Light Rose
  '#E5FFF0', // Light Mint
  '#FFF0E5', // Light Orange
  '#E5F0FF', // Light Lavender
  '#F5FFE5', // Light Lime
  '#FFE5FB', // Light Magenta
  '#E5FFFF', // Light Cyan
  '#FFEEE5', // Light Peach
  '#EEE5FF', // Light Violet
  '#E5FFEE', // Light Seafoam
  '#FFEFE5', // Light Coral
  '#F0FFE5', // Light Spring Green
  '#FFE5EE', // Light Blush
];

export const themeBackgrounds = {
  default: `linear-gradient(115deg, ${colors.blue} 0%, ${colors.blueLight} 100%)`,
  card: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #667eea 100%)',
  lightGrey: '#f6f0f085',
}

export const fontSizes = {
  graph: {
    axis: 12,
    tooltip: 12,
  }
}

const theme = createTheme({
  typography: {
    fontFamily: FONT_FAMILY.primary,
  },
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: `linear-gradient(115deg, ${colors.blue} 0%, ${colors.blueLight} 100%)`,
      // paper: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #667eea 100%)'
    },
  },
});

export default theme;
